import { axios } from '@/utils/request'
// 获取订单列表
export function getOrderList(params) {
  return axios({
    url: '/distribution/order',
    method: 'GET',
    params
  })
}
// 取消订单
export function deleteOrder(id) {
  return axios({
    url: '/distribution/order/' + id,
    method: 'DELETE'
  })
}
// 恢复订单
export function resumeOrder(id) {
  return axios({
    url: '/distribution/order/resume/' + id,
    method: 'GET'
  })
}
// 修改地址
export function upOrderAddrEs(data, id) {
  return axios({
    url: '/distribution/orderAddress/' + id,
    method: 'PUT',
    data
  })
}
// 获取当前群组用户列表
export function getUserMap(params) {
  return axios({
    url: '/distribution/user/getUserMap',
    method: 'GET',
    params
  })
}
// 查看成品
export function getProduct(id) {
  return axios({
    url: '/distribution/product/' + id,
    method: 'GET'
  })
}
// 关联订单项
export function bindOrderItem(data) {
  return axios({
    url: '/distribution/orderItem/bindOrderItem',
    method: 'POST',
    data
  })
}
// 修改订单项
export function modifyOrderItem(data, id) {
  return axios({
    url: '/distribution/orderItem/' + id,
    method: 'PUT',
    data
  })
}
// 拆分订单项
export function splitOrderItem(data, id) {
  return axios({
    url: '/distribution/orderItem/splitOrderItem/' + id,
    method: 'POST',
    data
  })
}
// 删除订单项
export function deleteOrderItem(id) {
  return axios({
    url: '/distribution/orderItem/' + id,
    method: 'DELETE'
  })
}
// 支付订单
export function orderPay(data) {
  return axios({
    url: '/distribution/orderPay',
    method: 'POST',
    data
  })
}
// 付订单详情
export function orderPayList(ids) {
  return axios({
    url: '/distribution/orderPay/' + ids,
    method: 'GET'
  })
}
// 获取物流列表
export function getLogistics(id) {
  return axios({
    url: '/distribution/order/logistics/' + id,
    method: 'GET'
  })
}
// 修改订单物流
export function saveLogistics(data, id) {
  return axios({
    url: '/distribution/order/saveLogistics/' + id,
    method: 'POST',
    data
  })
}
// 获取物流平台列表(单项订单物流)
export function getLogisticsPlatform(params) {
  return axios({
    url: '/api/logisticsPlatform',
    method: 'GET',
    params
  })
}
// 批量导出运单号
export function exportTrackNumber(data) {
  return axios({
    url: '/distribution/order/exportTrackNumber',
    method: 'POST',
    // responseType: 'blob',
    data
  })
}
// 获取上面自提列表
export function getPickUpList(params) {
  return axios({
    url: '/distribution/logisticsPickUpAddress',
    method: 'GET',
    params
  })
}
// 批量导入物流面单
export function importOrder(data) {
  return axios({
    url: '/distribution/order/importOrderLogistics',
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data
  })
}
// 批量修改物流预览
export function showBatch(params) {
  return axios({
    url: '/distribution/order/showBatchLogistics',
    method: 'GET',
    params
  })
}
// 批量修改物流
export function saveBatch(data) {
  return axios({
    url: '/distribution/order/saveBatchLogistics',
    method: 'POST',
    data
  })
}
// 物流平台列表（全部订单物流）
export function allLogistics() {
  return axios({
    url: '/distribution/logisticsPlatform',
    method: 'GET'
  })
}
// 同步订单
export function syncOrder() {
  return axios({
    url: '/distribution/order/syncOrder',
    method: 'POST'
  })
}
// 同步订单
export function viewLogistics(id) {
  return axios({
    url: '/distribution/orderLogistics/' + id,
    method: 'GET'
  })
}
// 异常订单数量
export function exceptionCount(params) {
  return axios({
    url: '/distribution/order/exceptionCount',
    method: 'GET',
    params
  })
}
// 订单数量
export function orderCount(params) {
  return axios({
    url: '/distribution/order/orderCount',
    method: 'GET',
    params
  })
}
// 催单
export function remind(id) {
  return axios({
    url: '/distribution/order/setRemind/' + id,
    method: 'PUT'
  })
}
// 获取复制订单信息
export function getCopyInfo(id) {
  return axios({
    url: '/distribution/order/copyInfo/' + id,
    method: 'GET'
  })
}
// 提交复制订单
export function copyOrder(data) {
  return axios({
    url: '/distribution/order/copy',
    method: 'POST',
    data
  })
}
// 订单添加备注
export function orderRemark(data, id) {
  return axios({
    url: '/distribution/order/' + id,
    method: 'PUT',
    data
  })
}
// 批量同步发货订单
export function shippedOrder(data) {
  return axios({
    url: '/distribution/order/ShippedOrder',
    method: 'POST',
    data
  })
}
// 获取设置销售金额的记录
export function getSalesAmountFees(params) {
  return axios({
    url: '/distribution/order/getSalesAmountFees',
    method: 'GET',
    params
  })
}
// 修改销售价格
export function updateSalesAmount(data) {
  return axios({
    url: '/distribution/order/updateSalesAmount',
    method: 'POST',
    data
  })
}
// 获取汇率
export function getFeesList(params) {
  return axios({
    url: '/distribution/fees',
    method: 'GET',
    params
  })
}
// 批量获取利润率
export function getSalesOrderProfitList(params) {
  return axios({
    url: '/distribution/order/getSalesOrderProfitList',
    method: 'GET',
    params
  })
}
// 删除订单
export function hideOrder(id) {
  return axios({
    url: '/distribution/order/hideOrder/' + id,
    method: 'GET'
  })
}
// 订单进度
export function getOrderProcess(id) {
  return axios({
    url: '/distribution/order/orderProcess/' + id,
    method: 'GET'
  })
}
// 订单进度
export function dealReviewException(data) {
  return axios({
    url: '/distribution/order/dealReviewException',
    method: 'POST',
    data
  })
}
// 获取订单报关信息
export function getOrderDeclaration(id) {
  return axios({
    url: '/distribution/order/getOrderDeclaration/' + id,
    method: 'GET'
  })
}
// 修改订单报关信息
export function updateOrderDeclaration(data) {
  return axios({
    url: '/distribution/order/updateOrderDeclaration',
    method: 'POST',
    data
  })
}
// 订单导出
export function exportOrder(data) {
  return axios({
    url: '/distribution/order/export',
    method: 'POST',
    data
  })
}
// 支付预览
export function getOrderPayable(params) {
  return axios({
    url: '/distribution/order/orderPayable',
    method: 'GET',
    params
  })
}

// 订单支付页面
// 打样列表
export function getPayProofing(params) {
  return axios({
    url: '/distribution/order/productProofing',
    method: 'GET',
    params
  })
}
// 贴标列表
export function getPayLabel(params) {
  return axios({
    url: '/distribution/order/productLabel',
    method: 'GET',
    params
  })
}
// 确定打样
export function putPayProofing(data) {
  return axios({
    url: '/distribution/order/productProofing',
    method: 'POST',
    data
  })
}
// 确定贴标
export function putPayLabel(data) {
  return axios({
    url: '/distribution/order/productLabel',
    method: 'POST',
    data
  })
}
// 生成运单号
export function reloadOrderLogistics(data) {
  return axios({
    url: '/distribution/order/reloadOrderLogistics',
    method: 'POST',
    data
  })
}
// 更新同步订单号设置
export function updatelsAutoSyncTrackingNumber(data) {
  return axios({
    url: '/distribution/order/updateIsAutoSyncTrackingNumber',
    method: 'POST',
    data
  })
}
// 获取第三方订单状态
export function getOrderThirdStatus(params) {
  return axios({
    url: '/distribution/order/getOrderThirdStatus',
    method: 'GET',
    params
  })
}
// 设置订单搁置状态
export function setCustomerStatus(data) {
  return axios({
    url: '/distribution/order/setCustomerStatus',
    method: 'POST',
    data
  })
}
// 颜色标记备注列表
export function getColorMarkingInfo() {
  return axios({
    url: '/distribution/colorMarkingInfo',
    method: 'GET'
  })
}
// 新增颜色标记备注
export function addColorMarkingInfo(data) {
  return axios({
    url: '/distribution/colorMarkingInfo',
    method: 'POST',
    data
  })
}
// 更新颜色标记备注
export function putColorMarkingInfo(data, id) {
  return axios({
    url: '/distribution/colorMarkingInfo/' + id,
    method: 'PUT',
    data
  })
}
// 设置订单颜色标记
export function setOrderColorMarking(data) {
  return axios({
    url: '/distribution/order/setOrderColorMarking',
    method: 'POST',
    data
  })
}
// 取消订单颜色标记
export function cancleOrderColorMarKing(data) {
  return axios({
    url: '/distribution/order/cancleOrderColorMarking',
    method: 'POST',
    data
  })
}
// 获取地址信息
export function getAddressAmount(params, id) {
  return axios({
    url: '/distribution/orderAddress/getAddressAmount/' + id,
    method: 'GET',
    params
  })
}

// 下载生产图
export function downloadProductImage(data) {
  return axios({
    url: '/distribution/order/exportDesignLayer',
    method: 'POST',
    data
  })
}

// 获取第三方平台物流商列表
export function getThirdLogisticsList(id) {
  return axios({
    url: '/distribution/order/thirdLogisticsProvider/' + id,
    method: 'get'
  })
}

// 手动发货
export function handlePostLogistics(id, data) {
  return axios({
    url: '/distribution/order/manualShipment/' + id,
    method: 'POST',
    data
  })
}
// 获取订单申报要素
export function getHsCodeItem(params) {
  return axios({
    url: '/distribution/order/getHsCodeItem',
    method: 'GET',
    params
  })
}
// 修改订单项申报要素
export function putHsCodeItem(data) {
  return axios({
    url: '/distribution/order/setHsCodeItem',
    method: 'POST',
    data
  })
}
